import React from "react";

import Banner from "../components/banner/Banner";
import InformationSection from "../components/information/InformationSection";

function Home() {
  return (
    <>
      <Banner />
      <InformationSection />
    </>
  );
}

export default Home;
